import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { LeagueDivision } from '../league-division.model';

@JsonObject('LeagueDivisionsResultsResponse')
export class LeagueDivisionsResultsResponse extends ApiResultsResponse<LeagueDivision> {

  @JsonProperty('results', [LeagueDivision])
  override results: LeagueDivision[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
